import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core';

const CircularProgressAbsolute = withStyles({
  root: {
    position: 'absolute',
  },
})(CircularProgress);

export const ButtonLoader = ({ show, ...props }) => {
  return show && <CircularProgressAbsolute size={32} {...props} />;
};

ButtonLoader.propTypes = {
  show: PropTypes.bool,
};

export default ButtonLoader;
